import React from 'react';

import styles from './styled-tags-components.module.scss';

/** Kept in sync with the matching values in styled-tags-components.module.scss. */
export const ADD_TAG_WIDTH = 4.8;
export const TAG_INNER_HORIZONTAL_PADDING = 0.8;

type TagProps = {
  color?: string;
};

const cx = (base: string, className?: string) => (className ? `${base} ${className}` : base);

export const Strip = ({ className, ...props }: React.ComponentPropsWithoutRef<'div'>) => (
  <div className={cx(styles['strip'], className)} {...props} />
);

export const Left = ({ className, ...props }: React.ComponentPropsWithoutRef<'div'>) => (
  <div className={cx(styles['left'], className)} {...props} />
);

export const Wrapper = ({ className, ...props }: React.ComponentPropsWithoutRef<'div'>) => (
  <div className={cx(styles['wrapper'], className)} {...props} />
);

export const TagLabel = ({
  color,
  className,
  style,
  ...props
}: React.ComponentPropsWithoutRef<'div'> & TagProps) => (
  <div
    className={cx(styles['tag-label'], className)}
    style={
      color
        ? ({
            '--tag-color': color,
            '--tag-color-hover': `${color}20`,
            ...style,
          } as React.CSSProperties)
        : style
    }
    {...props}
  />
);

export const Point = ({
  color,
  className,
  style,
  ...props
}: React.ComponentPropsWithoutRef<'div'> & TagProps) => (
  <div
    className={cx(styles['point'], className)}
    style={color ? ({ '--tag-color': color, ...style } as React.CSSProperties) : style}
    {...props}
  />
);
